import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import SEO from '../components/SEO';
import ContactForm from '../components/ContactForm';
import CopyEmailLink from '../components/CopyEmailLink';

const ContactPage = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-white" data-testid="contact-page">
      <SEO
        title={t('Contact | U&Fashion', 'Contact | U&Fashion')}
        description={t(
          'Neem contact op met U&Fashion. Vragen, suggesties of feedback? We horen graag van je.',
          'Get in touch with U&Fashion. Questions, suggestions or feedback? We\u2019d love to hear from you.'
        )}
        canonical={
          typeof window !== 'undefined' ? window.location.origin + '/contact' : 'https://uandfashion.eu/contact'
        }
      />

      <section className="bg-gradient-to-br from-gray-50 via-pink-50/40 to-purple-50/40 border-b border-gray-100">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 pt-20 pb-12 text-center">
          <p className="text-xs uppercase tracking-[0.35em] text-pink-500 mb-5">
            {t('Contact', 'Contact')}
          </p>
          <h1 className="text-4xl sm:text-5xl font-light text-gray-900 leading-[1.1] tracking-tight mb-5">
            {t('Laat van je horen.', 'Drop us a line.')}
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed font-light max-w-xl mx-auto">
            {t(
              'Vraag, suggestie, samenwerkingsvoorstel of gewoon feedback? We lezen elk bericht persoonlijk.',
              "Question, suggestion, partnership idea or just some feedback? We read every message personally."
            )}
          </p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 py-16">
        <ContactForm />
        <p className="text-center text-sm text-gray-500 mt-8">
          {t('Liever direct mailen? ', 'Prefer to email directly? ')}
          <CopyEmailLink
            email="info@uandfashion.eu"
            className="text-purple-600 underline hover:text-purple-800 cursor-pointer"
            testId="contact-direct-email"
          />
        </p>
      </section>
    </div>
  );
};

export default ContactPage;
